import Vue from 'vue'
import { focus } from './focus'
import { MGTrack } from './track'
import { telBehavior } from './telBehavior'

Vue.directive('focus', focus);
/*
usage: 字段属性详见指令文件
  v-track.view.click="{k:'',s:'',i:'',p:'',c1:'',c2:'',c3:''}"
*/
Vue.directive('track', MGTrack);

Vue.directive('telBehavior', telBehavior);


// WEBPACK FOOTER //
// ./src/directives/index.js